import { Injectable } from '@angular/core';
import {TopologyElementType} from '../../../../services/enums/topology-element-type.enum';
import {TopologyElementTitle} from '../../../../services/enums/topology-element-title.enum';
import {TopologyElementPrefix} from '../../../../services/enums/topology-element-prefix.enum';
import {MapSummaryApiService} from '../../../../network/services/map/map-summary-api/map-summary-api.service';

@Injectable({
  providedIn: 'root'
})
export class ChooseTopologyElementFromMapService {

  constructor() {}

  prepareOptionsForNodesAndPCons(isSelectionLegal, withOffline, selectedNodes, selectedPCons, nodes, pCons, keyStore): any {
    const isOfflineSelected = false;
    const preSelectedItems = {nodes: [], edges: []};

    preSelectedItems.nodes = this.getNodesMapIds(selectedNodes);
    preSelectedItems.edges = this.getPconsMapIds(selectedPCons);

    const selectedItemsObject = {node: [], voipPeer: [], pCon: [], connection: []};

    const selectionConfigurations = this.prepareSelectionSrcNodesAndPConsConfigurations(isSelectionLegal, isOfflineSelected, withOffline);

    return {
      isSingleSelection: false,
      selectedItemsObject,
      selectionConfigurations,
      preSelectedItems,
      storeKey: keyStore,
      type: 'nodesAndPCons'
    };
  }

  prepareOptionsForPCons(isSelectionLegal, withOffline, selectedPCons, pCons, keyStore = null): any {
    const isOfflineSelected = false;
    const preSelectedItems = {nodes: [], edges: []};

    preSelectedItems.edges = this.getPconsMapIds(selectedPCons);

    const selectedItemsObject = {node: [], voipPeer: [], pCon: [], connection: []};

    const selectionConfigurations = this.prepareSelectionSrcNodesAndPConsConfigurations(isSelectionLegal, isOfflineSelected, withOffline);

    return {
      isSingleSelection: false,
      selectedItemsObject,
      selectionConfigurations,
      preSelectedItems,
      storeKey: keyStore,
      type: 'pCons'
    };
  }

  prepareOptionsForNodes(isSelectionLegal, withOffline, selectedNodes, nodes, keyStore = null): any {
    const isOfflineSelected = false;
    const preSelectedItems = {nodes: [], edges: []};

    preSelectedItems.nodes = this.getNodesMapIds(selectedNodes);

    const selectedItemsObject = {node: [], voipPeer: [], pCon: [], connection: []};

    const selectionConfigurations = this.prepareSelectionSrcNodesAndPConsConfigurations(isSelectionLegal, isOfflineSelected, withOffline);

    return {
      isSingleSelection: false,
      selectedItemsObject,
      selectionConfigurations,
      preSelectedItems,
      storeKey: keyStore,
      type: 'nodes'
    };
  }

  prepareOptionsForDashboard(nodes, pCons, keyStore): any {
    const preSelectedItems = {nodes: [], edges: []};

    const selectionConfigurations = this.prepareSelectionSrcNodesAndPConsConfigurations(true, false, false);

    return {
      isSingleSelection: false,
      selectionConfigurations,
      preSelectedItems,
      viewOnly: true,
      storeKey: keyStore,
      type: keyStore
    };
  }

  prepareOptionsForNodesPConsAndVoipPeer(isSelectionLegal, withOffline, selectedNodes, selectedPCons, selectedVPeers,
                                         nodes, pCons, voipPeers): any {
    const isOfflineSelected = false;
    const preSelectedItems = {nodes: [], edges: []};

    preSelectedItems.nodes = [...this.getNodesMapIds(selectedNodes), ...this.getVoipPeersMapIds(selectedVPeers)];
    preSelectedItems.edges = this.getPconsMapIds(selectedPCons);

    const selectedItemsObject = {node: [], voipPeer: [], pCon: [], connection: []};

    const selectionConfigurations = this.prepareSelectionSrcNodesAndPConsConfigurations(isSelectionLegal, isOfflineSelected, withOffline);
    return {
      isSingleSelection: true,
      selectedItemsObject,
      selectionConfigurations,
      preSelectedItems,
      type: 'nodesPConsAndVoipPeer'
    };
  }

  private getNodesMapIds(selected): any {
    return selected.map(node => TopologyElementPrefix.node + node);
  }

  private getPconsMapIds(selected): any {
    return selected.map(pcon => TopologyElementPrefix.peer_connection + pcon);
  }

  private getVoipPeersMapIds(selected): any {
    return selected.map(voipPeer => TopologyElementPrefix.voip_peer + voipPeer);
  }

  private prepareSelectionSrcNodesAndPConsConfigurations(isSelectionLegal, isOfflineSelected, withOffline): any {
    return {
      withOffline,
      isCombinedViewDisplayed: isOfflineSelected,
      multipleSelection: true,
      isSelectionLegal
    };
  }

  private handleTopologyItemsSelection(selectedItemsObject, type, selected): any {
    if (type === TopologyElementType.node) {
      selected = [];
      selectedItemsObject.node.forEach((selectedNode) => {selected.push(selectedNode.dataItem.id); });
    } else {
      selected = [];
      selectedItemsObject.pCon.forEach((selectedPCon) => {selected.push(selectedPCon.dataItem.id); });
    }
    return selected;
  }
}
